import SvgSearch from '@img/icons/search.svg';
import * as React from 'react';
import DesktopNavigationLink from '../DesktopNavigationLink/DesktopNavigationLink';
import S from './DesktopNavigation.styles';
const DesktopNavigation = ({ items, reduced = false, onSearchToggle, }) => {
    return (React.createElement(S.Container, { "aria-label": "Main Navigation - Desktop" },
        React.createElement(S.ItemList, null,
            items.map((item) => (React.createElement(DesktopNavigationLink, { key: item.id, item: item }))),
            !reduced && (React.createElement(S.Item, null,
                React.createElement(S.Link, { as: "button", "aria-label": "Toggle Search Overlay", onClick: (event) => {
                        event.preventDefault();
                        onSearchToggle();
                    } },
                    React.createElement(SvgSearch, null)))))));
};
export default DesktopNavigation;
